import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SearchPage from './pages/SearchPage';
import AdminPage from './pages/AdminPage';
import HomePage from './pages/HomePage';
import StudentPage from './pages/StudentPage';
import TaskPage from './pages/TaskPage';
import LoginPage from './pages/LoginPage';
import TeacherGuard from './components/guard/TeacherGuard';
import AdminGuard from './components/guard/AdminGuard';
import AdminDrivingGuard from './components/guard/AdminDrivingGuard';
import MeInvoicePage from './pages/MeInvoicePage';
import AdminLoginPage from './pages/AdminLoginPage';
import A1APage from './pages/A1APage';
import MeInvoiceBatchPage from './pages/MeInvoiceBatchPage';
import InvoiceOcrPage from './pages/InvoiceOcrPage';
import DoiChieuBangKePage from './pages/DoiChieuBangKePage';
import CalcomPage from './pages/CalcomPage';
import AdminCalcomPage from './pages/AdminCalcomPage';
import CabinTrungLichPage from './pages/CabinTrungLichPage';
import DrivingPaymentPage from './pages/DrivingPaymentPage';

// V2 pages — call uniapp-backend (`staging-api.uniapp.vn`) instead of
// the legacy n8n webhooks. Kept side-by-side with V1 routes during the
// migration trial. See docs/v2-migration-from-n8n.md for the plan.
import SearchPageV2 from './pages/v2/SearchPageV2';
import AdminPageV2 from './pages/v2/AdminPageV2';
import AuditLogPageV2 from './pages/v2/AuditLogPageV2';
import StudentPageV2 from './pages/v2/StudentPageV2';
import HomePageV2 from './pages/v2/HomePageV2';
import IntegrationSettingsPageV2 from './pages/v2/IntegrationSettingsPageV2';
import ReportPageV2 from './pages/v2/ReportPageV2';
import DatSummaryReportPageV2 from './pages/v2/DatSummaryReportPageV2';
import TotNghiepPageV2 from './pages/v2/TotNghiepPageV2';
import TotNghiepOcrPageV2 from './pages/v2/TotNghiepOcrPageV2';
import KqshRetentionPageV2 from './pages/v2/KqshRetentionPageV2';
import ProfilePageV2 from './pages/v2/ProfilePageV2';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path='/driving/payment' element={<DrivingPaymentPage />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='/admin/login' element={<AdminLoginPage />} />
        {/*
         * DAT pages — V2 (uniapp-backend) is now the DEFAULT at the
         * canonical URLs. V1 (legacy n8n) is kept under /v1/* for
         * side-by-side comparison / rollback. /a1a is NOT part of the
         * DAT cutover (it uses GetFly + driving APIs, not n8n DAT).
         */}
        <Route
          path='/'
          element={
            <TeacherGuard>
              <HomePageV2 />
            </TeacherGuard>
          }
        />
        <Route
          path='/a1a'
          element={
            <TeacherGuard>
              <A1APage />
            </TeacherGuard>
          }
        />
        <Route
          path='/search'
          element={
            <TeacherGuard>
              <SearchPageV2 />
            </TeacherGuard>
          }
        />
        {/* Hồ sơ của chính mình — TeacherGuard chứ không phải AdminGuard: ai
            đăng nhập được cũng phải đổi được mật khẩu của mình, kể cả vai
            DAT_TEACHER vốn không mở được các trang /admin/*. */}
        <Route
          path='/user/profile'
          element={
            <TeacherGuard>
              <ProfilePageV2 />
            </TeacherGuard>
          }
        />
        <Route
          path='/admin/session'
          element={
            <AdminGuard>
              <AdminPageV2 />
            </AdminGuard>
          }
        />
        <Route
          path='/admin/session/student'
          element={
            <AdminGuard>
              <StudentPageV2 />
            </AdminGuard>
          }
        />
        <Route
          path='/admin/session/audit-log'
          element={
            <AdminGuard>
              <AuditLogPageV2 />
            </AdminGuard>
          }
        />
        <Route
          path='/admin/session/report'
          element={
            <AdminGuard>
              <ReportPageV2 />
            </AdminGuard>
          }
        />
        {/* Ghép danh sách học viên với tổng hợp DAT (thay pipeline Python
            dat-report). Cùng AdminGuard với các trang báo cáo khác. */}
        {/* Điểm thi tốt nghiệp. Cùng AdminDrivingGuard với màn OCR hoá đơn:
            nhập liệu là việc bàn giấy hằng ngày của giáo viên và người làm báo
            cáo, còn quyền GHI thì backend siết riêng (chỉ ADMIN / DRIVING.ADMIN
            mới commit được). */}
        <Route
          path='/admin/tot-nghiep'
          element={
            <AdminDrivingGuard>
              <TotNghiepPageV2 />
            </AdminDrivingGuard>
          }
        />
        <Route
          path='/admin/tot-nghiep/ocr'
          element={
            <AdminDrivingGuard>
              <TotNghiepOcrPageV2 />
            </AdminDrivingGuard>
          }
        />
        <Route
          path='/admin/session/dat-summary'
          element={
            <AdminGuard>
              <DatSummaryReportPageV2 />
            </AdminGuard>
          }
        />
        <Route
          path='/admin/integrations'
          element={
            <AdminGuard>
              <IntegrationSettingsPageV2 />
            </AdminGuard>
          }
        />

        {/* Legacy V1 (n8n) DAT pages — kept for comparison / rollback. */}
        <Route
          path='/v1'
          element={
            <TeacherGuard>
              <HomePage />
            </TeacherGuard>
          }
        />
        <Route
          path='/v1/search'
          element={
            <TeacherGuard>
              <SearchPage />
            </TeacherGuard>
          }
        />
        <Route
          path='/v1/admin/session'
          element={
            <AdminGuard>
              <AdminPage />
            </AdminGuard>
          }
        />
        <Route
          path='/v1/admin/session/student'
          element={
            <AdminGuard>
              <StudentPage />
            </AdminGuard>
          }
        />
        <Route path='/task' element={<TaskPage />} />
        <Route
          path='/admin/meinvoice'
          element={
            <AdminDrivingGuard>
              <MeInvoicePage />
            </AdminDrivingGuard>
          }
        />
        <Route
          path='/admin/meinvoice/batch'
          element={
            <AdminDrivingGuard>
              <MeInvoiceBatchPage />
            </AdminDrivingGuard>
          }
        />
        {/*
         * Tra cứu bảo lưu hồ sơ sát hạch. AdminDrivingGuard chứ không phải
         * TeacherGuard: tập vai trò của guard này (ADMIN, DRIVING.ADMIN,
         * TEACHER, REPORTER) khớp đúng quyền ĐỌC của /v2/kqsh bên
         * uniapp-backend, nên không có chuyện vào được trang rồi ăn 403.
         * Nhập file kết quả KHÔNG ở đây — nó nằm ở uniapp-frontend
         * /admin/getfly/kqsh, nơi sau này có nút đồng bộ sang GetFly.
         */}
        <Route
          path='/admin/kqsh'
          element={
            <AdminDrivingGuard>
              <KqshRetentionPageV2 />
            </AdminDrivingGuard>
          }
        />
        {/* Duyệt hoá đơn AI đọc được, rồi ghi vào MeInvoice. Cùng guard với
         * /admin/meinvoice vì đây là cùng một luồng công việc. */}
        <Route
          path='/admin/meinvoice/ocr'
          element={
            <AdminDrivingGuard>
              <InvoiceOcrPage />
            </AdminDrivingGuard>
          }
        />
        {/* Đối chiếu bảng kê .xlsx của kế toán. Cùng guard với /admin/meinvoice
         * vì cùng một luồng, và luồng này chỉ ĐỌC nên không cần hẹp hơn. */}
        <Route
          path='/admin/meinvoice/doi-chieu'
          element={
            <AdminDrivingGuard>
              <DoiChieuBangKePage />
            </AdminDrivingGuard>
          }
        />
        <Route
          path='/cabin'
          element={
            <TeacherGuard>
              <CalcomPage />
            </TeacherGuard>
          }
        />
        <Route
          path='/admin/cabin'
          element={
            <AdminDrivingGuard>
              <AdminCalcomPage />
            </AdminDrivingGuard>
          }
        />
        {/* Cảnh báo lịch cabin trùng — người duyệt đọc rồi tự bấm hủy từng dòng,
         * không có gì tự hủy. Cùng guard với /admin/cabin vì cùng một công việc,
         * và backend còn chặn thêm đúng tập vai được hủy lịch. */}
        <Route
          path='/admin/cabin/trung-lich'
          element={
            <AdminDrivingGuard>
              <CabinTrungLichPage />
            </AdminDrivingGuard>
          }
        />

      </Routes>
    </Router>
  );
}
